<template>
  <v-app>
    <v-app-bar app color="white" elevation="1">
      <v-container class="py-0 fill-height">
        <v-row align="center" justify="space-between">
          <v-col cols="auto">
            <v-img :src="logo" max-width="120" contain class="mr-4"></v-img>
          </v-col>
          <v-col>
            <h1 class="text-left text-h6 grey--text text--darken-2 font-weight-medium">
              {{ currentUser ? `${currentUser.name}님이 접속하셨습니다test.` : '' }}
            </h1>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <v-divider class="blue-divider"></v-divider>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import logo from '@/assets/prone_logo.jpeg'

export default {
  name: 'DefaultLayout',
  setup() {
    const store = useStore()
    const currentUser = computed(() => store.state.auth.user)

    return {
      currentUser,
      logo
    }
  }
}
</script>

<style scoped>
.blue-divider {
  height: 8px !important;
  background-color: #1976D2 !important;
}

.text-left {
  text-align: left;
}
</style>
